document.querySelectorAll('.InputRange').forEach((el) => {
   const input = el.querySelector('input[type=text]');
   const range = el.querySelector('input[type=range]');
   const rangeBase = el.querySelector('.RangeBase');

   input.IMask.on('accept', () => {
       range.value = input.IMask.typedValue;
       range.dispatchEvent(new Event('update'));
   })
    rangeBase.addEventListener('touchstart', () => {
       if(document.activeElement) {
           document.activeElement.blur();
       }
   })
    range.addEventListener('input', () => {
        input.IMask.value = range.value.replace('.', ',');
   })
});
